<template>
  <div>
    <b-modal id="bv-modal-return-product" size="lg" hide-footer>
      <template #modal-title>Return product</template>

      <div class="row">
        <div class="col">
            <label>Please choose a reason for returning this product</label>
            <select class="form-control2" v-model="reasonId" @change="updateReason(reasonId)">
                <option value="1">Wrong product delivered</option>
                <option value="2">Product does not meet my expectations</option>
                <option value="3">Product no longer wanted</option>
                <option value="4">Product delivered in a poor or damaged condition</option>
                <option value="5">Missing parts or accessories</option>
                <option value="6">Product is defective or does not work</option>
                <option value="7">Description on website not accurate</option>
            </select>
        </div>
      </div>

      <div class="row pt-3 pb-2">
        <div class="col">
        <button v-if="updating" type="button" class="btn btn-success submit col">
          <i class="fas fa-spinner fa-sm fa-spin mr-2 move-up"></i></button>
        <button v-else type="button" class="btn btn-danger submit col" @click="submitRequest">Submit Request</button>
        </div>
      </div>

    </b-modal>
  </div>
</template> 

<script>
export default {
props: ['orderProductId'],

  data() {
    return {
      updating: false,
      reasonId: null,
    };
  },

  methods: {

    clearInfo() {
      this.reasonId = null;
    },

    hideModalReturnProduct() {
      this.$bvModal.hide('bv-modal-return-product');
    },

    updateReason(item) {
        this.reasonId = item;
    },

    submitRequest() {

        if (!this.reasonId) { this.sweetfire('Please select a reason')}

        else {
        
            this.updating = true;

            axios
            .post('/returns/add', {
                reasonId: this.reasonId,
                orderProductId: this.orderProductId,
                })
            .then((response) => {

            if (response.data.success) {
                console.log(response.data)
                this.$emit('return-product', this.orderProductId);
                this.hideModalReturnProduct();
            } else {
                this.sweetfire(response.data.message);
            }

            this.updating = false;

            });

          }

      },

      sweetfire(text) {

      Swal.fire({
      title: text,
      showConfirmButton: false,
      showDenyButton: false,
      showCancelButton: true,
      focusConfirm: false,
      cancelButtonText: 'Ok',
      customClass: {
              title: "popup-title",
            },
    })

    },
  },
};
</script>